const HeroVideoFrame = ({ children }) => (
  <div className="mk-hero-video-frame relative">
    <svg
      className="mk-hero-video-frame__outline pointer-events-none absolute -inset-3 h-[calc(100%+24px)] w-[calc(100%+24px)] sm:-inset-4 sm:h-[calc(100%+32px)] sm:w-[calc(100%+32px)]"
      viewBox="0 0 160 90"
      preserveAspectRatio="none"
      aria-hidden="true"
    >
      <rect
        className="mk-hero-video-frame__path"
        x="1"
        y="1"
        width="158"
        height="88"
        rx="8"
        pathLength="1"
      />
    </svg>
    <div className="relative z-10 overflow-hidden rounded-[20px] border border-slate-200/80 bg-slate-950">
      {children}
    </div>
    <style>{`
      .mk-hero-video-frame__outline {
        overflow: visible;
      }

      .mk-hero-video-frame__path {
        fill: none;
        stroke: #8b4afa;
        stroke-width: 2;
        stroke-linecap: round;
        stroke-dasharray: 0.18 0.82;
        animation: mk-hero-outline 7s linear infinite;
        vector-effect: non-scaling-stroke;
        will-change: stroke-dashoffset;
      }

      @keyframes mk-hero-outline {
        to { stroke-dashoffset: -1; }
      }

      @media (prefers-reduced-motion: reduce) {
        .mk-hero-video-frame__path { animation: none; }
      }
    `}</style>
  </div>
);

export default HeroVideoFrame;